import React from 'react'
import { connect } from 'react-redux'
import { Menu } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import store from 'store'
import _ from 'lodash'
import actions from 'redux/virtual/event/actions'
import agendaActions from 'redux/virtual/agenda/actions'
import chatActions from 'redux/virtual/chat/actions'
import eshopActions from 'redux/virtual/eshop/actions'
import userActions from 'redux/virtual/user/actions'
import styles from './style.module.scss'
// import ProfileMenu from './ProfileMenu'

const { SubMenu, Divider } = Menu

const mapStateToProps = ({ virtualMenu, virtualSettings, virtualUser, virtualEvent, Chat }) => ({
  menuData: virtualMenu.menuTopData,
  isVirtualLightTheme: virtualSettings.isVirtualLightTheme,
  isSidebarOpen: virtualSettings.isSidebarOpen,
  avatarType: virtualUser.avatarType,
  avatarData: virtualUser.avatarData,
  avatarColor: virtualUser.avatarColor,
  name: virtualUser.name,
  designation: virtualUser.designation,
  organization: virtualUser.organization,
  isAgendaOpen: virtualSettings.isAgendaOpen,
  isSpeakersOpen: virtualSettings.isSpeakersOpen,
  isBriefcaseOpen: virtualSettings.isBriefcaseOpen,
  isLeadsOpen: virtualSettings.isLeadsOpen,
  isMeetingsOpen: virtualSettings.isMeetingsOpen,
  isBriefCaseCalled: virtualEvent.isBriefCaseCalled,
  isLeaderBoardOpen: virtualEvent.isLeaderBoardOpen,
  isEShopOpen: virtualEvent.isEShopOpen,
  // isLeaderBoardCalled: virtualEvent.isLeaderBoardCalled,
  theHistory: virtualEvent.theHistory,
  chatvisitedonce: Chat.chatvisitedonce,
  currentTab: Chat.currentTab,
  visitedExhibitors: Chat.visitedExhibitors,
})

@withRouter
@connect(mapStateToProps)
class MenuTop extends React.Component {
  state = {
    selectedKeys: store.get('app.virtualMenu.selectedKeys') || [],
  }

  componentWillMount() {
    this.setSelectedKeys(this.props)
  }

  componentWillReceiveProps(newProps) {
    this.setSelectedKeys(newProps)
  }

  setSelectedKeys = props => {
    const { menuData } = this.props
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    const selectedItem = _.find(flattenItems(menuData, 'children'), [
      'url',
      props.location.pathname,
    ])
    this.setState({
      selectedKeys: selectedItem ? [selectedItem.key] : [],
    })
  }

  handleClick = e => {
    const {
      dispatch,
      isSidebarOpen,
      isAgendaOpen,
      isBriefcaseOpen,
      isLeadsOpen,
      isMeetingsOpen,
      isBriefCaseCalled,
      theHistory,
      chatvisitedonce,
      currentTab,
      isSpeakersOpen,
      isLeaderBoardOpen,
      // isLeaderBoardCalled,
      visitedExhibitors,
      isEShopOpen,
    } = this.props
    store.set('app.virtualMenu.selectedKeys', [e.key])
    if (e.key === 'sidebar') {
      if (!chatvisitedonce && currentTab === 'attendees') {
        dispatch({
          type: 'chat/GET_ALL_USERS',
        })
      }
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isSidebarOpen',
          value: !isSidebarOpen,
        },
      })
      return
    }
    if (e.key === 'back') {
      const tempHistory = theHistory
      tempHistory.pop()
      dispatch({
        type: actions.SET_STATE,
        payload: {
          theHistory: tempHistory,
        },
      })
      dispatch({
        type: actions.FILTER_SCENE,
        payload: {
          id: tempHistory[tempHistory.length - 1],
        },
      })

      return
    }
    if (e.key === 'sidebar') {
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isSidebarOpen',
          value: !isSidebarOpen,
        },
      })
      return
    }
    if (e.key === 'helpdesk') {
      const helpdeskID = '38e5c1b-4b1d-df52-308a-177665c1ce7'
      const tempvisitedExhibitors = visitedExhibitors

      tempvisitedExhibitors[helpdeskID] = {
        login_status: true,
        name: 'GBS Helpdesk',
        avatar_data:
          'https://storage.googleapis.com/wiz365/d67c8af7-709b-11eb-ae70-2fc0e19a87cf.jpg',
        avatar_type: 'image',
      }

      dispatch({
        type: chatActions.SET_STATE,
        payload: {
          currentChat: helpdeskID,
          currentScreen: 'chatWindow',
          userType: 'business',
          currentTab: 'messages',
          visitedExhibitors: tempvisitedExhibitors,
        },
      })

      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isSidebarOpen',
          value: !isSidebarOpen,
        },
      })
      return
    }
    if (e.key === 'pointredeem') {
      dispatch({
        type: 'pointredeem/SET_STATE',
        payload: {
          isPointRedeemOpen: true,
        },
      })
      return
    }
    if (e.key === 'logout') {
      dispatch({
        type: 'virtaluser/LOGOUT',
      })
      return
    }
    if (e.key === 'agenda') {
      dispatch({
        type: agendaActions.GET_AGENDA,
        payload: {},
      })
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isAgendaOpen',
          value: !isAgendaOpen,
        },
      })
      return
    }

    if (e.key === 'auditorium') {
      const { history } = this.props
      history.push(`/virtual/main?scene=63a31ed-534-bfd2-0663-3fbcecd8230&mode=navigation`)
      return
    }

    if (e.key === 'resources') {
      dispatch({
        type: actions.SET_STATE,
        payload: {
          currentClickSection:'51d853c-2b38-e2ab-063-c888247e6b3',
          isDocumentListVisible: true,
        },
      })
      return
    }
    if (e.key === 'feedback') {
      // dispatch({
      //   type: actions.SET_STATE,
      //   payload: {
      //     isDocumentListVisible: true,
      //   },
      // })
      window.open('https://forms.gle/MiMxnmyh5aGCCVAd6', '_blank')
      return
    }



    if (e.key === 'photobooth') {
      dispatch({
        type: 'photobooth/SET_STATE',
        payload: {
          isPhotoboothOpen: true,
        },
      })
      return
    }

    if (e.key === 'directory') {
      dispatch({
        type: actions.SET_STATE,
        payload: {
          directoryVisible: true,
        },
      })
      return
    }
    if (e.key === 'visitedstalls') {
      dispatch({
        type: userActions.SET_STATE,
        payload: {
          isViewedStallsOpen: true,
        },
      })
      return
    }

    if (e.key === 'speakers') {
      console.log('clicked on speakers')
      console.log(isSpeakersOpen)
      dispatch({
        type: agendaActions.GET_SPEAKERS,
        payload: {},
      })
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isSpeakersOpen',
          value: !isSpeakersOpen,
        },
      })
      return
    }
    if (e.key === 'leaderBoard') {
      console.log('clicked on Leaderboard')
      console.log(isLeaderBoardOpen)
      dispatch({
        type: actions.GET_LEADERBOARD,
        payload: {},
      })
      dispatch({
        type: actions.SET_STATE,
        payload: {
          isLeaderBoardOpen: !isLeaderBoardOpen,
        },
      })
      return
    }
    if (e.key === 'eShop') {
      dispatch({
        type: actions.GET_LEADERBOARD,
        payload: {},
      })
      dispatch({
        type: eshopActions.GET_GIFTS,
        payload: {},
      })
      dispatch({
        type: actions.SET_STATE,
        payload: {
          isEShopOpen: !isEShopOpen,
        },
      })
      return
    }
    if (e.key === 'briefcase') {
      if (!isBriefCaseCalled) {
        dispatch({
          type: actions.GET_BRIEFCASE,
          payload: {},
        })
      }
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isBriefcaseOpen',
          value: !isBriefcaseOpen,
        },
      })
      return
    }
    if (e.key === 'leads') {
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isLeadsOpen',
          value: !isLeadsOpen,
        },
      })
      return
    }
    if (e.key === 'meeting') {
      if (!isMeetingsOpen) {
        dispatch({
          type: 'meetings/GET_MEETING',
        })
      }
      dispatch({
        type: 'virtualSettings/CHANGE_SETTING',
        payload: {
          setting: 'isMeetingsOpen',
          value: !isMeetingsOpen,
        },
      })
      return
    }
    if (e.key === 'home') {
      dispatch({
        type: actions.GET_DEFAULT_SCENE,
      })
      return
    }
    // if (e.key === 'navigation') {
    //   dispatch({
    //     type: actions.FILTER_NAVIGATION_SCENE,
    //   })
    //   return
    // }
    // if (e.key === 'back') {
    //   if(lastPath != "")
    //   {
    //     dispatch({
    //       type: actions.GET_DEFAULT_SCENE
    //     })
    //   }

    //   return
    // }
    this.setState({
      selectedKeys: [e.key],
    })
  }

  generateMenuItems = () => {
    const { menuData = [] } = this.props
    const generateItem = item => {
      const { key, title, url, icon, pro, disabled } = item
      if (item.divider) {
        return <Divider key={Math.random()} />
      }
      if (item.url) {
        return (
          <Menu.Item key={key} disabled={disabled}>
            {item.target ? (
              <a href={url} target={item.target} rel="noopener noreferrer">
                {icon && <span className={`${icon} ${styles.icon}`} />}
                <span className={styles.title}>{title}</span>
                {pro && <span className="badge badge-primary ml-2">PRO</span>}
              </a>
            ) : (
              <Link to={url}>
                {icon && <span className={`${icon} ${styles.icon}`} />}
                <span className={styles.title}>{title}</span>
                {pro && <span className="badge badge-primary ml-2">PRO</span>}
              </Link>
            )}
          </Menu.Item>
        )
      }
      return (
        <Menu.Item key={key} disabled={disabled}>
          {icon && <span className={`${icon} ${styles.icon}`} />}
          <span className={styles.title}>{title}</span>
          {pro && <span className="badge badge-primary ml-2">PRO</span>}
        </Menu.Item>
      )
    }
    const generateSubmenu = items =>
      items.map(menuItem => {
        if (menuItem.children) {
          const subMenuTitle = (
            <span className={styles.menu} key={menuItem.key}>
              <span className={styles.title}>{menuItem.title}</span>
              {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
            </span>
          )
          return (
            <SubMenu title={subMenuTitle} key={menuItem.key}>
              {generateSubmenu(menuItem.children)}
            </SubMenu>
          )
        }
        return generateItem(menuItem)
      })
    return menuData.map(menuItem => {
      if (menuItem.children) {
        const subMenuTitle = (
          <span className={styles.menu} key={menuItem.key}>
            <span className={styles.title}>{menuItem.title}</span>
            {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
          </span>
        )
        return (
          <SubMenu title={subMenuTitle} key={menuItem.key}>
            {generateSubmenu(menuItem.children)}
          </SubMenu>
        )
      }
      return generateItem(menuItem)
    })
  }

  render() {
    const { selectedKeys } = this.state
    const { isVirtualLightTheme } = this.props
    return (
      <div>
        <div className={styles.logo}>
          <div className={`${styles.logoContainer} text-center`}>
            <img src="resources/images/logo-inverse.png" alt="logo" />
          </div>
        </div>
        <Menu
          theme={isVirtualLightTheme ? 'light' : 'dark'}
          onClick={this.handleClick}
          selectedKeys={selectedKeys}
          mode="horizontal"
        >
          {this.generateMenuItems()}
        </Menu>
        {/* <div className={styles.avatar}>
          <div className={styles.avatarContainer}>
            <ProfileMenu style={{ lineHeight: 0 }} />
          </div>
        </div> */}
      </div>
    )
  }
}

export default MenuTop
